module.exports = __webpack_public_path__ + "img/pbt_photo_07.d078920c.jpg";